import type { KeyValueStore } from '../core';
import { sfx } from '../audio/sfx';
import { browserStore } from './loadoutStore';

const KEY = 'critter.volume';

export interface Volumes {
  music: number;
  sound: number;
}

export function parseVolumes(raw: string | null): Volumes {
  if (!raw) return { music: 1, sound: 1 };
  try {
    const data = JSON.parse(raw) as Partial<Volumes>;
    return { music: clamp(data.music), sound: clamp(data.sound) };
  } catch {
    return { music: 1, sound: 1 };
  }
}

export function loadVolumes(store: KeyValueStore = browserStore): Volumes {
  return parseVolumes(store.getItem(KEY));
}

export function saveVolumes(volumes: Volumes, store: KeyValueStore = browserStore): void {
  store.setItem(KEY, JSON.stringify({ music: clamp(volumes.music), sound: clamp(volumes.sound) }));
  sfx.setMusicVolume(volumes.music);
  sfx.setSoundVolume(volumes.sound);
}

export function installVolumes(store: KeyValueStore = browserStore): void {
  const volumes = loadVolumes(store);
  sfx.musicVolume = volumes.music;
  sfx.soundVolume = volumes.sound;
  sfx.setMusicVolume(volumes.music);
  sfx.setSoundVolume(volumes.sound);
}

function clamp(value: number | undefined): number {
  if (typeof value !== 'number' || !Number.isFinite(value)) return 1;
  return Math.min(1, Math.max(0, value));
}
